var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('inline-field-actions',{attrs:{"schema":_vm.schema}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.schema.staticText)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }